import { takeEvery, call, put } from 'redux-saga/effects'
import { RESET_PASSWORD_FORM_SUBMIT } from '../../constants/employer'
import { API_SERVER } from '../../constants'
import { registerPost } from '../../utils/employer/request'
import {
  resetPasswordSubmitSuccess,
  resetPasswordSubmitFailed
} from '../../actions/employer/index'

/**
 * resetPassword.saga of employer side is copied from resetPassword.saga user side
 * if this is updated, let check and done the same things with user side
 */

/**
 * @author Pragya Gupta
 */

function* resetPasswordSaga({ formValues }) {
  try {
    const email = formValues.email
    const body = JSON.stringify({ email: email })
    const url = `${API_SERVER}/EmployerResetPassword`
    const result = yield call(registerPost, url, body)

    if (result.data === 'Employer password reset successfully') {
      yield put(resetPasswordSubmitSuccess())
    } else {
      yield put(resetPasswordSubmitFailed())
    }
  } catch (e) {
    yield put(resetPasswordSubmitFailed(e))
  }
}

export function* watchResetPasswordSaga() {
  yield takeEvery(RESET_PASSWORD_FORM_SUBMIT, resetPasswordSaga)
}
